import React, { useState } from "react";
import { Container } from "..";
import { Accordion } from "../../../../../app/components";
import { Edit as EditIcon } from "@material-ui/icons";
import EditNotesInput from "../edit.notes.input";
import { IconButton, makeStyles } from "@material-ui/core";
import CustomTooltip from "../../../../../app/components/tooltip/custom.tooltip";
import CustomRow from "../../../../../app/components/custom.tables.components/custom.row";
import CustomCell from "../../../../../app/components/custom.tables.components/custom.cell";
import { useRestoreTableVisibility } from "../../hooks/useRestoreTableVisibility";
import { DATA_TABLE_NAME } from "../../constants";
import { toParticipantUiText } from "../../../../../app/utils/participantTerminology";

const EDITABLE_FIELDS = [
  "CDA Site/Participant Reporting, Average Frequency / Hours to generate",
];

const HEADER_DATA = [
  { width: "30%", textAlign: "right", label: "" },
  { width: "10%", label: "Number" },
  { width: "10%", label: "Hours" },
  { width: "10%", label: "" },
  { width: "40%", label: "Notes" },
];

export default function CDATable({ data, setEditOpen, readOnly }) {
  const [editState, setEditState] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);
  const classes = useIconButtonStyles();

  useRestoreTableVisibility('CDATable', setIsExpanded);

  const renderHeader = () => (
    <CustomRow>
      {HEADER_DATA.map((col, idx) => (
        <CustomCell
          key={idx}
          variant="header"
          justify={col.textAlign ? col.textAlign : undefined}
          width={col.width}
          style={col.textAlign ? { borderBottom: "none" } : {}}
        >
          {col.label}
        </CustomCell>
      ))}
    </CustomRow>
  );

  const renderRows = () => {
    return data.map((d, idx) => {
      return (
        <CustomRow key={idx}>
          <CustomCell
            variant="header"
            justify="flex-end"
            width={HEADER_DATA[0].width}
            style={{
              borderBottom: "none",
              position: "relative",
              paddingLeft: "20px",
            }}
            textAlign="right"
          >
            {toParticipantUiText(d.rowLabel)}
            {(!readOnly && EDITABLE_FIELDS.includes(d.rowLabel?.trim())) && (
              <IconButton
                variant="text"
                color="primary"
                onClick={() => setEditOpen(true)}
                className={classes.iconButton}
              >
                <EditIcon className={classes.editIcon} />
              </IconButton>
            )}
          </CustomCell>
          <CustomCell width={HEADER_DATA[1].width}>
            <CustomTooltip title={d.cellValue1?.toString() || ''}>
              <div>{d.cellValue1}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width={HEADER_DATA[2].width}>
            <CustomTooltip title={d.cellValue2?.toString() || ''}>
              <div>{d.cellValue2}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width={HEADER_DATA[3].width}>
            <CustomTooltip title={d.cellValue3?.toString() || ''}>
              <div>{d.cellValue3}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell
            style={{
              position: "relative",
            }}
            textAlign="left"
            justify="flex-start"
            width={HEADER_DATA[4].width}
          >
            <EditNotesInput
              d={d}
              editState={editState}
              setEditState={setEditState}
              readOnly={readOnly}
            />
          </CustomCell>
        </CustomRow>
      );
    });
  };

  return (
    <Accordion
      scrollIntoView={true}
      width={"100%"}
      summary={"CDA Participant Review Time"}
      defaultExpanded={isExpanded}
      onChange={(e, expanded) => setIsExpanded(expanded)}
      data-table-name={DATA_TABLE_NAME.CDA_TABLE}
    >
      <Container 
        onClick={(e) => e.stopPropagation()} 
        data-table-name={DATA_TABLE_NAME.CDA_TABLE}
        data-table-container="true"
      >
        {renderHeader()}
        {renderRows()}
      </Container>
    </Accordion>
  );
}

const useIconButtonStyles = makeStyles(() => ({
  iconButton: {
    position: "absolute",
    left: "5px",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "4px",

    "&:hover": {
      backgroundColor: "var(--teal-100)",
    },
    "&:active": {
      backgroundColor: "var(--teal-300)",
    },
  },
  editIcon: {
    width: "1rem",
    height: "1rem",
  },
}));
